module.exports = __webpack_public_path__ + "media/images/athletes/1678-a22f19892302a1c1f188cc840b4feefe.png";